import React from 'react';
import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 28, className = '', as = 'div' }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </Tag>
  );
};

export const SectionHeading = ({ eyebrow, title, subtitle, light = false, align = 'left', testId }) => {
  const eyebrowColor = light ? 'text-gold' : 'text-bordeaux';
  const titleColor = light ? 'text-cream' : 'text-ink';
  const subColor = light ? 'text-cream/70' : 'text-ink/60';
  const alignCls = align === 'center' ? 'text-center items-center mx-auto' : '';
  return (
    <div className={`flex flex-col gap-5 max-w-2xl ${alignCls}`} data-testid={testId}>
      <Reveal>
        <span className={`eyebrow ${eyebrowColor}`}>{eyebrow}</span>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className={`font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1] ${titleColor}`}>
          {title}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.2}>
          <p className={`text-base md:text-lg leading-relaxed ${subColor}`}>{subtitle}</p>
        </Reveal>
      )}
    </div>
  );
};
